
import React, { useEffect, useState } from 'react';
import SelectableCard from './SelectableCard/SelectableCard';
import { useCardStore } from "../../stores/cardStore";
import { useGameStateStore } from "../../stores/gameStateStore";
import "./CardsContainer.css"


export default function CardsContainer() {
  const [isDisabled, setIsDisabled] = useState(false);
  const roundStatus = useGameStateStore(s => s.roundStatus);

  const cards = useCardStore(c => c.cards);

  useEffect(() => {
    if (roundStatus !== "waiting") {
      setIsDisabled(true);
    }
  }, [isDisabled, roundStatus])

  return (
    <div className="cards-container">
      {
        cards.map((card, aI) => {
          return <SelectableCard cardId={card.cardId} numbers={card.numbers} key={`bingo-card-list-${aI}`} disabled={isDisabled} />
        })
      }
    </div>
  )
}